import { z } from 'zod';

export const InfobarPayload = z.object({
  enabled: z.boolean().optional(),
  iconUrl: z.string().optional(),
  message: z.string(),
});
export type InfobarPayload = z.infer<typeof InfobarPayload>;

export const HeroBannerPayload = z.object({
  enabled: z.boolean().optional(),
  imageUrl: z.string(),
  mobileImageUrl: z.string().optional(),
  redirectUrl: z.string().optional(),
});
export type HeroBannerPayload = z.infer<typeof HeroBannerPayload>;

export const HubPersonalization = z.object({
  infobar: InfobarPayload.nullable().optional(),
  heroBanner: HeroBannerPayload.nullable().optional(),
});
export type HubPersonalization = z.infer<typeof HubPersonalization>;
